class RemoveBtn {
  mounted = false;
}

export default RemoveBtn;
